import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

interface OrderButtonProps {
  onClick: () => void;
}

export const OrderButton = ({ onClick }: OrderButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <ShoppingCart className="h-4 w-4" />
  </Button>
);